import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kasse-data-view',
  imports: [CommonModule],
  templateUrl: './kasse.list-view.html',
  styleUrls: ['./kasse.list-view.scss'],
})
export class KasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
